import React from 'react';
import { Cushion, Grid, ShimmerAvatar, ShimmerTypography } from '@pitchero/react-ui';

const ReplyLoadingPlaceholder = () => (
  <Cushion vertical="small">
    <Grid columns="32px 1fr 80px" columnGap="small">
      <div style={{ gridRow: 'span 2' }}>
        <ShimmerAvatar size={32} />
      </div>
      <ShimmerTypography />
      <ShimmerTypography />
      <div style={{ gridColumn: 'span 2' }}>
        <ShimmerTypography />
      </div>
    </Grid>
  </Cushion>
);

export default ReplyLoadingPlaceholder;
